import Icon from '../components/Icon.vue'

Icon.register({
  blind: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M380.1 510.8A8-8 0 0 0 369.2 508.1L243.8 301.7A31.9-31.9 0 0 1 256.8 292.2L382.8 499.8A8-8 0 0 0 380.2 510.8zM142.8 314.3L110.3 403.8 146.4 492.1C153.1 508.5 171.8 516.3 188.1 509.6 204.5 502.9 212.3 484.2 205.6 467.9L142.8 314.3zM96 88C120.3 88 140 68.3 140 44S120.3 0 96 0 52 19.7 52 44 71.7 88 96 88zM250.8 257.1L130.8 105.1C126.1 99.1 119.1 96 112 96V96H80V96C72.9 96 65.8 99.2 61.1 105.3L0 183.8V279.5C0 292.9 11 304.3 24.5 304 37.5 303.7 48 293.1 48 280V200.2L64 179.7V320.4L9.9 469.1C3.9 485.7 12.5 504 29.1 510.1 45.7 516.1 64 507.5 70.1 490.9L136 309.6V202.4L104.6 162.6A4-4 0 1 0 110.9 157.7L213.2 286.9C222.3 298.5 237.5 298.2 246.9 290.8 257.3 282.6 259 267.5 250.8 257.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/blind.js
// module id = vJC/
// module chunks = 144